"use client";
import React, { createContext, useContext } from "react";
import type { Attribute } from "@/types/pim";

export interface AttributeOption {
  value: any;
  count: number;
  disabled?: boolean;
  code?: string;
}

export interface InventoryFiltersData {
  attributes: Attribute[];
  attributeValues: Record<string, any[]>;
  availableValues: Record<string, AttributeOption[]>;
  /** Recalculated subcategory counts when filters are active; null = static counts. */
  subcategoryCounts: Record<number, number> | null;
}

const EMPTY: InventoryFiltersData = {
  attributes: [],
  attributeValues: {},
  availableValues: {},
  subcategoryCounts: null,
};

const InventoryFiltersContext = createContext<InventoryFiltersData>(EMPTY);

/**
 * Provides the server-computed filter datasets (attribute definitions, distinct
 * values, and availability/counts) to the client filter islands, so they render
 * from props instead of fetching on the client. Fed by the page's server render
 * and refreshed on every navigation (each filter change re-runs the server).
 */
export function InventoryFiltersProvider({
  value,
  children,
}: {
  value: InventoryFiltersData;
  children: React.ReactNode;
}) {
  return (
    <InventoryFiltersContext.Provider value={value}>
      {children}
    </InventoryFiltersContext.Provider>
  );
}

export function useInventoryFilters(): InventoryFiltersData {
  return useContext(InventoryFiltersContext);
}
